import 'firebase/auth';
import axios from '@/axios';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

export default {
  fetchNoticeBoardItems() {
    return axios.get('/api/v1/prismic/getNoticeBoardItems');
  },
  fetchSupplierTrainingItems() {
    return axios.get('/api/v1/prismic/getSupplierTrainingItems');
  },
  fetchAllResources() {
    return axios.get('/api/v1/prismic/getResources');
  },
  fetchPublishedProtocolsResources() {
    return axios.get('/api/v1/prismic/getPublishedProtocolsResources');
  },
};
